import Vue from 'vue';
// import Sortable from 'sortablejs';

// v-tableDraggable: 表格拖拽排序属性
// tableData  表格绑定数据
export default { 
    bind(el, binding, vnode) {
        const vm = vnode.context
        const dataName = binding.value.dataName
        const table = el.querySelector('.el-table__body-wrapper > table')
        const tbody = table.querySelector('tbody')
        new Sortable(tbody, {
            animation: 300,
            handle: '.el-table__row', //可拖拽的class名
            // filter:'.nonoDraggable',  //不可拖拽的class名
            onEnd: (evt) => {
                const oldIndex = evt.oldIndex
                const newIndex = evt.newIndex
                vm[dataName].splice(newIndex, 0, vm[dataName].splice(oldIndex, 1)[0])
                let arrLength = vm[dataName].length
                vm[dataName].forEach(item=>{
                    item.sort = arrLength
                    arrLength = arrLength - 1
                })
                // binding.value.callback()
                binding.value.callback && binding.value.callback()
            }
        })
    },
    unbind(el) {
        // 清理实例，避免内存泄漏
        el._sortable?.destroy()
    }
}